export const Messages = {
  TOO_MANY_FILES: 'Maximum number of files that can be uploaded cannot be greater than',
  FILE_INVALID_TYPE: 'One or more uploaded files are of invalid type'
}
